let authRun = ($rootScope, $state, $window, OAuth, sharedService, cacheService) => {
    "ngInject";

    $rootScope.$on('oauth:error', function (event, rejection) {

        // Ignore `invalid_grant` error - should be catched on `LoginController`.
        if ('invalid_grant' === rejection.data.error && 400 === rejection.status && 
            ($state.is('auth.login') || $state.is('onTheBeach.login'))) {
            return;
        }

        // Refresh token when a `invalid_token` error or a `invalid_grant` error and status 400 occurs
        if ('invalid_token' === rejection.data.error || (
            // Patch related with: https://github.com/oauthjs/angular-oauth2/issues/32
            401 === rejection.status && 'invalid_grant' === rejection.data.error
        )) {
            if (sharedService.refreshingToken) {
                return;
            }
            sharedService.refreshingToken = true;
            return OAuth.getRefreshToken().then(() => {
                sharedService.refreshingToken = false;
                $state.reload('home');
            });
        }

        // Redirect to the same login page with the `error_reason`.
        const currentState = $state.current.name;
        const targetState = currentState.includes('onTheBeach') ? 'onTheBeach.login' : 'auth.login';
        $state.go(targetState, {
            'error_reason': rejection.data.error
        });
        event.preventDefault();
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

        const unauthenticatedStates = ['auth.login', 'onTheBeach.login', 'old_goldupgrade', 'tab_name'];

        if (OAuth.isAuthenticated()) {
            if (toState.name === 'onTheBeach.login') {
                const language = toParams.locale || fromParams.locale;
                $state.go('onTheBeach.booking.view', { locale: language });
                event.preventDefault();
            } else if (toState.name === 'auth.login') {
                const language = toParams.locale || fromParams.locale;
                const bookingReference = cacheService.get('bookingReference');
                $state.go('bookings.booking.view', { locale: language, bookingReference: bookingReference });
                event.preventDefault();
            }
        }
        else {
            // User isn't authenticated
            if (toState.name === 'tab_name' && toParams.tab === undefined) {
                $state.go('auth.login');
                event.preventDefault();
            } else if (unauthenticatedStates.indexOf(toState.name) === -1) {
                const area = toState.name.startsWith('onTheBeach') ? 'onTheBeach' : 'auth';
                $state.go(`${area}.login`);
                event.preventDefault();
            }
        }
    });
};

export default authRun;


// WEBPACK FOOTER //
// ./client/app/common/auth/auth.run.js